export enum ContactSpatialSearchRecordTypeEnum {
  contact = 'contact',
  property = 'property',
  // searches like `property`, but the map draws the matching properties instead of the contacts
  propertyPins = 'property_pins',
}
